import React from 'react';
import ClientList from '../../components/clients/ClientList';
import ClientDetail from '../../components/clients/ClientDetail';

const Client: React.FC = () => {

    return (<div>
        <ClientDetail/>
    </div>)
};

export default Client;